// Angular
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-modal-wrapper',
    templateUrl: './modal-wrapper.component.html',
    styleUrls: ['./modal-wrapper.component.scss'],
    standalone: false
})
export class ModalWrapperComponent {
    @Input() ready: boolean = false;

    @Output() dismiss: EventEmitter<void> = new EventEmitter<void>();
}
